// extracted by mini-css-extract-plugin
module.exports = {"Description":"floor-page-module--Description--6BKqh","MovieChannelImage":"floor-page-module--MovieChannelImage--2nu_N"};